import { useState } from 'react';

export default function PalletizerBasics() {
  const [showConsultationForm, setShowConsultationForm] = useState(false);
  const [showContactForm, setShowContactForm] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleConsultationSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d3c7ni6enqf2o6v54fog', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });
      
      if (response.ok) {
        alert('お問い合わせありがとうございます。担当者より3営業日以内にご連絡いたします。');
        form.reset();
        setShowConsultationForm(false);
      }
    } catch (error) {
      alert('送信に失敗しました。お電話でのお問い合わせもお受けしております。');
    }
  };

  const handleContactSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d3c7ni6enqf2o6v54fo0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });
      
      if (response.ok) {
        alert('お問い合わせありがとうございます。担当者より3営業日以内にご連絡いたします。');
        form.reset();
        setShowContactForm(false);
      }
    } catch (error) {
      alert('送信に失敗しました。お電話でのお問い合わせもお受けしております。');
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-slate-800 text-white py-4 px-6">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <div className="flex items-center space-x-4">
            <a href="/" className="text-2xl font-bold hover:text-orange-400 cursor-pointer" style={{ fontFamily: '"Arial", "Helvetica", sans-serif' }}>パレタイザーナビ</a>
          </div>
          
          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <a href="/palletizer-basics" className="hover:text-orange-400 transition-colors cursor-pointer">パレタイザーとは</a>
            <a href="/selection-guide" className="hover:text-orange-400 transition-colors cursor-pointer">機種選定ガイド</a>
            <a href="/decision-criteria" className="hover:text-orange-400 transition-colors cursor-pointer">導入判断基準</a>
            <a href="/case-studies" className="hover:text-orange-400 transition-colors cursor-pointer">導入事例</a>
            <a href="/manufacturers-products" className="hover:text-orange-400 transition-colors cursor-pointer">メーカー・製品</a>
            <a href="/peripheral-systems" className="hover:text-orange-400 transition-colors cursor-pointer">周辺機器</a>
            <a href="/alternatives-comparison" className="hover:text-orange-400 transition-colors cursor-pointer">代替案・比較</a>
          </nav>

          <div className="flex items-center space-x-6">
            <button 
              onClick={() => setShowConsultationForm(true)}
              className="bg-orange-500 hover:bg-orange-600 px-6 py-3 rounded-lg font-bold whitespace-nowrap cursor-pointer transition-colors"
            >
              見積依頼・お問い合わせ
            </button>
            
            {/* Mobile Menu Button */}
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden text-white cursor-pointer"
            >
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-slate-700">
            <nav className="flex flex-col space-y-4 mt-4">
              <a href="/palletizer-basics" className="hover:text-orange-400 transition-colors cursor-pointer">パレタイザーとは</a>
              <a href="/selection-guide" className="hover:text-orange-400 transition-colors cursor-pointer">機種選定ガイド</a>
              <a href="/decision-criteria" className="hover:text-orange-400 transition-colors cursor-pointer">導入判断基準</a>
              <a href="/case-studies" className="hover:text-orange-400 transition-colors cursor-pointer">導入事例</a>
              <a href="/manufacturers-products" className="hover:text-orange-400 transition-colors cursor-pointer">メーカー・製品</a>
              <a href="/peripheral-systems" className="hover:text-orange-400 transition-colors cursor-pointer">周辺機器</a>
              <a href="/alternatives-comparison" className="hover:text-orange-400 transition-colors cursor-pointer">代替案・比較</a>
              <button 
                onClick={() => {
                  setShowConsultationForm(true);
                  setMobileMenuOpen(false);
                }}
                className="bg-orange-500 hover:bg-orange-600 px-4 py-2 rounded-lg font-bold whitespace-nowrap cursor-pointer transition-colors text-left"
              >
                見積依頼・お問い合わせ
              </button>
            </nav>
          </div>
        )}
      </header>

      {/* Breadcrumb */}
      <div className="bg-slate-50 py-4 px-6">
        <div className="max-w-7xl mx-auto">
          <nav className="flex items-center space-x-2 text-sm text-slate-600">
            <a href="/" className="hover:text-blue-600 cursor-pointer">ホーム</a>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-slate-800 font-semibold">パレタイザーの基礎知識</span>
          </nav>
        </div>
      </div>

      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-5xl font-bold mb-6">パレタイザーの基礎知識</h1>
          <p className="text-xl text-blue-100 mb-8">自動積み付け設備の仕組みとメリットを詳しく解説</p>
        </div>
      </section>

      {/* What is Palletizer Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-slate-800 mb-6">パレタイザーとは？</h2>
              <p className="text-lg text-slate-600 mb-6">
                パレタイザーは、段ボール箱や袋などの製品を自動的にパレット上に積み付ける産業用ロボットです。
                人手による重労働を自動化し、24時間無人稼働により生産性向上とコスト削減を実現します。
              </p>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-check-line text-blue-600 text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-800 mb-1">高精度な積み付け</h3>
                    <p className="text-slate-600">プログラムされたパターンで正確に積み付け、荷崩れを防止</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-check-line text-blue-600 text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-800 mb-1">24時間連続稼働</h3>
                    <p className="text-slate-600">人手不足を解消し、夜間や休日も無人で生産継続</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-check-line text-blue-600 text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-800 mb-1">作業環境改善</h3>
                    <p className="text-slate-600">重労働から作業者を解放し、安全性を大幅向上</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Industrial%20palletizer%20robot%20in%20modern%20factory%20setting%2C%20automated%20stacking%20system%20with%20boxes%20on%20wooden%20pallets%2C%20clean%20manufacturing%20environment%2C%20professional%20lighting%2C%20technical%20diagram%20overlay%20showing%20robotic%20arm%20movement&width=600&height=400&seq=palletizer-basics-main&orientation=landscape"
                alt="パレタイザーの基本構造"
                className="w-full h-96 object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-slate-800 mb-16">導入による4つのメリット</h2>
          <div className="grid lg:grid-cols-2 gap-8">
            {[
              {
                icon: 'ri-money-dollar-circle-line',
                title: '人件費削減',
                description: '年間500万円以上のコスト削減実績',
                details: [
                  '作業員3名から1名体制へ削減可能',
                  '夜勤・残業代の大幅カット',
                  '2-3年で投資回収完了'
                ],
                color: 'green'
              },
              {
                icon: 'ri-speed-up-line',
                title: '生産性向上',
                description: '処理能力の大幅アップ',
                details: [
                  '1時間あたり400-800ケース処理',
                  '24時間連続稼働で生産量2倍',
                  'ライン停止時間の最小化'
                ],
                color: 'blue'
              },
              {
                icon: 'ri-shield-check-line',
                title: '負荷軽減',
                description: '作業者の身体的負担を大幅軽減',
                details: [
                  '重量物の手作業を完全自動化',
                  '腰痛・肩こりなどの労災リスク軽減',
                  '作業者の定着率向上'
                ],
                color: 'purple'
              },
              {
                icon: 'ri-error-warning-line',
                title: 'ミス防止',
                description: '積み付けミスによる荷崩れを防止',
                details: [
                  'プログラム制御で正確な積み付け',
                  '品質の安定化とクレーム削減',
                  '出荷効率の向上'
                ],
                color: 'red'
              }
            ].map((benefit, index) => (
              <div key={index} className="bg-white p-8 rounded-lg shadow-lg">
                <div className={`w-16 h-16 bg-${benefit.color}-100 rounded-full flex items-center justify-center mb-6`}>
                  <i className={`${benefit.icon} text-3xl text-${benefit.color}-600`}></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-800 mb-3">{benefit.title}</h3>
                <p className="text-lg text-slate-600 mb-4">{benefit.description}</p>
                <ul className="space-y-2">
                  {benefit.details.map((detail, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className={`ri-check-line text-${benefit.color}-600 mr-2 mt-1`}></i>
                      <span className="text-slate-600">{detail}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Applications Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-slate-800 mb-16">パレタイザーの応用例</h2>
          <div className="grid lg:grid-cols-3 gap-8">
            {[
              {
                title: '製品種類別積み付け',
                description: '段ボール、袋、プラケースなど様々な製品に対応',
                image: 'https://readdy.ai/api/search-image?query=Various%20packaging%20types%20being%20palletized%2C%20cardboard%20boxes%2C%20plastic%20bags%2C%20containers%2C%20automated%20sorting%20and%20stacking%20system%2C%20industrial%20warehouse%20setting&width=400&height=300&seq=palletizer-applications-1&orientation=landscape',
                features: ['多品種対応', '形状認識', '積み付けパターン自動選択']
              },
              {
                title: 'カゴ台車積み付け',
                description: '物流業界での効率的な積み付けシステム',
                image: 'https://readdy.ai/api/search-image?query=Industrial%20robot%20loading%20roll%20cage%20trolleys%20in%20logistics%20warehouse%2C%20automated%20material%20handling%20system%2C%20organized%20storage%20facility&width=400&height=300&seq=palletizer-applications-2&orientation=landscape',
                features: ['物流効率化', '省スペース', '迅速配送対応']
              },
              {
                title: '開梱システム連携',
                description: '受入から積み付けまでトータル自動化',
                image: 'https://readdy.ai/api/search-image?query=Automated%20unpacking%20and%20palletizing%20system%2C%20conveyor%20belts%20with%20box%20opening%20robots%2C%20integrated%20warehouse%20automation%2C%20modern%20logistics%20facility&width=400&height=300&seq=palletizer-applications-3&orientation=landscape',
                features: ['完全自動化', 'トレーサビリティ', '品質管理']
              }
            ].map((application, index) => (
              <div key={index} className="bg-slate-50 rounded-lg overflow-hidden shadow-lg">
                <img 
                  src={application.image}
                  alt={application.title}
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold text-slate-800 mb-3">{application.title}</h3>
                  <p className="text-slate-600 mb-4">{application.description}</p>
                  <div className="space-y-2">
                    {application.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center">
                        <i className="ri-check-line text-blue-600 mr-2"></i>
                        <span className="text-sm text-slate-600">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Price Guide Section */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-slate-800 mb-16">価格の目安と費用構成</h2>
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="bg-white p-8 rounded-lg shadow-lg">
                <h3 className="text-2xl font-bold text-slate-800 mb-6">導入費用の目安</h3>
                <div className="space-y-4">
                  <div className="flex justify-between items-center p-4 bg-blue-50 rounded-lg">
                    <span className="font-semibold">直交ロボット型</span>
                    <span className="text-xl font-bold text-blue-600">900万円〜</span>
                  </div>
                  <div className="flex justify-between items-center p-4 bg-green-50 rounded-lg">
                    <span className="font-semibold">多関節ロボット型</span>
                    <span className="text-xl font-bold text-green-600">1,500万円〜</span>
                  </div>
                  <div className="flex justify-between items-center p-4 bg-purple-50 rounded-lg">
                    <span className="font-semibold">機械式</span>
                    <span className="text-xl font-bold text-purple-600">2,000万円〜</span>
                  </div>
                </div>
                <p className="text-sm text-slate-600 mt-4">※本体価格のみ。周辺機器・工事費別途</p>
              </div>
            </div>
            <div>
              <h3 className="text-2xl font-bold text-slate-800 mb-6">費用構成の内訳</h3>
              <div className="space-y-4">
                {[
                  { item: '本体機器', ratio: '60%', description: 'ロボット本体・制御装置' },
                  { item: '周辺機器', ratio: '20%', description: 'コンベア・安全装置・センサー' },
                  { item: '設置工事', ratio: '15%', description: '基礎工事・電気工事・配管' },
                  { item: 'その他', ratio: '5%', description: '試運転・研修・保証' }
                ].map((cost, index) => (
                  <div key={index} className="flex items-center space-x-4">
                    <div className="w-16 text-right">
                      <span className="text-lg font-bold text-slate-800">{cost.ratio}</span>
                    </div>
                    <div className="flex-1">
                      <div className="flex justify-between items-center mb-1">
                        <span className="font-semibold text-slate-800">{cost.item}</span>
                      </div>
                      <p className="text-sm text-slate-600">{cost.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-6 p-4 bg-yellow-50 rounded-lg">
                <p className="text-sm text-yellow-800">
                  <i className="ri-information-line mr-2"></i>
                  パレタイザーには様々な種類があり、機能性なども異なるため、本体価格は約900万円から多種多様に存在します。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-blue-600 text-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-8">パレタイザー導入を検討されていますか？</h2>
          <p className="text-xl mb-8">現状分析から最適機種選定まで、専門スタッフが無料でサポートいたします</p>
          <div className="flex justify-center space-x-6">
            <a 
              href="/selection-guide"
              className="bg-white text-blue-600 hover-bg-slate-100 px-10 py-4 rounded-lg text-lg font-bold whitespace-nowrap cursor-pointer transition-colors"
            >
              機種選定ガイドはこちら
            </a>
            <button 
              onClick={() => setShowConsultationForm(true)}
              className="bg-orange-500 hover:bg-orange-600 px-10 py-4 rounded-lg text-lg font-bold whitespace-nowrap cursor-pointer transition-colors"
            >
              無料相談はこちら
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-800 text-white py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Arial", "Helvetica", sans-serif' }}>パレタイザーナビ</h3>
              <p className="text-slate-300 mb-4">パレタイザー専門企業として、製造業・物流業の自動化をサポートします。</p>
              <div className="flex space-x-4">
                <i className="ri-phone-line text-orange-400"></i>
                <span>03-1234-5678</span>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-bold mb-4">サービス</h4>
              <ul className="space-y-2 text-slate-300">
                <li><a href="/selection-guide" className="hover:text-orange-400 cursor-pointer">機械式パレタイザー</a></li>
                <li><a href="/selection-guide" className="hover:text-orange-400 cursor-pointer">多関節ロボット</a></li>
                <li><a href="/selection-guide" className="hover:text-orange-400 cursor-pointer">直交ロボット</a></li>
                <li><a href="/peripheral-systems" className="hover:text-orange-400 cursor-pointer">保守・メンテナンス</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-bold mb-4">詳細情報</h4>
              <ul className="space-y-2 text-slate-300">
                <li><a href="/palletizer-basics" className="hover:text-orange-400 cursor-pointer">パレタイザーとは</a></li>
                <li><a href="/decision-criteria" className="hover:text-orange-400 cursor-pointer">導入判断基準</a></li>
                <li><a href="/case-studies" className="hover:text-orange-400 cursor-pointer">導入事例</a></li>
                <li><a href="/manufacturers-products" className="hover:text-orange-400 cursor-pointer">メーカー・製品</a></li>
                <li><a href="/peripheral-systems" className="hover:text-orange-400 cursor-pointer">周辺機器・システム</a></li>
                <li><a href="/alternatives-comparison" className="hover:text-orange-400 cursor-pointer">代替案・比較</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-bold mb-4">会社情報</h4>
              <ul className="space-y-2 text-slate-300">
                <li>〒174-0000 東京都板橋区</li>
                <li>設立：1985年</li>
                <li>従業員数：120名</li>
                <li>ISO9001認証取得</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-slate-700 mt-8 pt-8 text-center text-slate-400">
            <p>&copy; 2024 パレタイザーナビ. All rights reserved. | 
              <a href="https://readdy.ai/?origin=logo" className="text-orange-400 hover:text-orange-300 ml-2">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </footer>

      {/* Consultation Form Modal */}
      {showConsultationForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-2xl font-bold text-slate-800">お問い合わせ・見積もり</h3>
                <button 
                  onClick={() => setShowConsultationForm(false)}
                  className="text-slate-500 hover:text-slate-700 cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
              <form id="consultation-form" data-readdy-form onSubmit={handleConsultationSubmit} className="space-y-4">
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">会社名 *</label>
                    <input 
                      type="text" 
                      name="company" 
                      required 
                      className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">お名前 *</label>
                    <input 
                      type="text" 
                      name="name" 
                      required 
                      className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">電話番号 *</label>
                    <input 
                      type="tel" 
                      name="phone" 
                      required 
                      className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">メールアドレス *</label>
                    <input 
                      type="email" 
                      name="email" 
                      required 
                      className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">業種</label>
                  <select name="industry" className="w-full p-3 pr-8 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                    <option value="">選択してください</option>
                    <option value="食品・飲料">食品・飲料</option>
                    <option value="化学・医薬品">化学・医薬品</option>
                    <option value="物流・倉庫">物流・倉庫</option>
                    <option value="その他製造業">その他製造業</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">現在の課題・ご要望</label>
                  <textarea 
                    name="requirements" 
                    rows={4} 
                    maxLength={500}
                    className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="現在の作業状況や導入を検討している理由をお聞かせください（500文字以内）"
                  ></textarea>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">希望連絡方法</label>
                  <div className="flex space-x-4">
                    <label className="flex items-center">
                      <input type="radio" name="contact_method" value="電話" className="mr-2" />
                      電話
                    </label>
                    <label className="flex items-center">
                      <input type="radio" name="contact_method" value="メール" className="mr-2" />
                      メール
                    </label>
                    <label className="flex items-center">
                      <input type="radio" name="contact_method" value="どちらでも" className="mr-2" defaultChecked />
                      どちらでも
                    </label>
                  </div>
                </div>
                <button 
                  type="submit" 
                  className="w-full bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-lg font-bold whitespace-nowrap cursor-pointer transition-colors"
                >
                  送信する
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Contact Form Modal */}
      {showContactForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-2xl font-bold text-slate-800">資料ダウンロード</h3>
                <button 
                  onClick={() => setShowContactForm(false)}
                  className="text-slate-500 hover:text-slate-700 cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
              <form id="contact-form" data-readdy-form onSubmit={handleContactSubmit} className="space-y-4">
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">会社名 *</label>
                    <input 
                      type="text" 
                      name="company" 
                      required 
                      className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">お名前 *</label>
                    <input 
                      type="text" 
                      name="name" 
                      required 
                      className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">メールアドレス *</label>
                  <input 
                    type="email" 
                    name="email" 
                    required 
                    className="w-full p-3 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">ご希望の資料</label>
                  <div className="space-y-2">
                    <label className="flex items-center">
                      <input type="checkbox" name="materials" value="パレタイザー総合カタログ" className="mr-2" />
                      パレタイザー総合カタログ
                    </label>
                    <label className="flex items-center">
                      <input type="checkbox" name="materials" value="導入事例集" className="mr-2" />
                      導入事例集
                    </label>
                    <label className="flex items-center">
                      <input type="checkbox" name="materials" value="コスト削減効果資料" className="mr-2" />
                      コスト削減効果資料
                    </label>
                    <label className="flex items-center">
                      <input type="checkbox" name="materials" value="補助金活用ガイド" className="mr-2" />
                      補助金活用ガイド
                    </label>
                  </div>
                </div>
                <button 
                  type="submit" 
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-bold whitespace-nowrap cursor-pointer transition-colors"
                >
                  資料をダウンロード
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
